// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            dataNote: [
                {
                    label: 'Some things to note when fixed MAC address',
                    children: [
                        {
                            label: '• This feature will help you to fix our physical hardware for the next time you boot your computer.',
                        },
                        {
                            label: '• You will not be able to boot the machine if the physical machine you fixed is in use.',
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.DISCONNECT_INTERNET_MACHINE);
        },

        //#region Hardware fixation
        confirm() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    isDisconnectedInternet: !this.targetImage.isDisconnectedInternet,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.DISCONNECT_INTERNET_MACHINE, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess(
                            this.$t('disconnectInternetMachineModal.successTitle'),
                            this.$t(data.hardwareFixation ? 'disconnectInternetMachineModal.successMessageFixed' : 'disconnectInternetMachineModal.successMessageRemoved', { id: this.targetImage.id, name: this.targetImage.name })
                        );
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('disconnectInternetMachineModal.failedMessage'))
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}